import { createContext } from 'react';
import { defaultProps } from "../constants";
export var DropdownContext = /*#__PURE__*/createContext({
  selectedOptionAltText: defaultProps.selectedOptionAltText
});
DropdownContext.displayName = 'DropdownContext';